import {App, Button, Divider, Flex, Form, Input, Tag, Typography} from "antd";
import {getRequestWithParams} from "../../../api/httpRequest";
import {useState} from "react";
import {useNavigate} from "react-router";

export default function PasswordResetContent() {

    const [isLogging, setIsLogging] = useState(false)
    const {notification} = App.useApp()
    const navigate = useNavigate();
    const [form]  = Form.useForm();
    const [errorForm, setErrorForm]  = useState<boolean>(false);

    function getErrorMessage(error: any): string {
        if (error?.response?.data?.message) return error.response.data.message;
        if (typeof error?.response?.data === 'string') return error.response.data;
        if (error?.message) return error.message;
        return 'Логин не зарегистрирован в системе';
    }

    async function handleReset(values: any) {
        setIsLogging(true);
        try {
            await getRequestWithParams("/server/api/auth/resetPass", {login: values.login});
            notification.success({
                message: `Ссылка для сброса пароля отправлена на электронную почту`,
                duration: 3
            });
            navigate("/login");
        } catch (error) {
            const message = getErrorMessage(error);
            notification.error({
                message: message,
                duration: 3
            });
            setErrorForm(true);
        } finally {
            setIsLogging(false);
        }
    }

    function resetForm() {
        return <Form
            form={form}
            name="request"
            labelCol={{flex: '70px'}}
            labelAlign="left"
            onFinish={values => handleReset(values)}
            requiredMark={false}>
            <Form.Item
                label="Логин"
                name="login"
                validateStatus={errorForm? "error"  :  ""}
                help={errorForm ? "Логин не зарегистрирован в системе" :""}
                rules={[{required: true, message: 'Логин не может быть пустым!'}]}>
                <Input status={errorForm? "error" : ""}/>
            </Form.Item>
            <Form.Item
                style={{padding: 0, margin: 0}}>
                <Button loading={isLogging} style={{width: "150px", height: "38.5px"}} type="primary"
                        htmlType="submit">
                    Сбросить пароль
                </Button>
            </Form.Item>
        </Form>;
    }

    return (
        <Flex className={"content"} vertical={true}>
            <Flex vertical gap={"16px"}>
                <div className={"lkText"}>Забыли пароль?</div>
                <div className={"continueText"}>Для сброса пароля, пожалуйста, введите логин (электронную почту)</div>
                <Tag style={{width: "100%", whiteSpace: "pre-wrap"}} color={"processing"}>
                    Ссылка для сброса будет действительна в течение 5 минут
                </Tag>
            </Flex>
            <Divider style={{margin: 16}}/>
            {resetForm()}
        </Flex>
    )
}
